import { ref } from "vue";

export const useMenu = () => {
  const isMenuOpen = ref(false);

  const showMenu = () => {
    isMenuOpen.value = true;
  };

  const closeMenu = () => {
    isMenuOpen.value = false;
  };

  const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
  };

  return {
    // Состояние
    isMenuOpen,

    // Методы
    showMenu,
    closeMenu,
    toggleMenu,
  };
};
